// extracted by mini-css-extract-plugin
export default {"root":"top_actions_panel-module___root___af55d923"};